import styled from 'styled-components';
import { getColor } from 'utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  background-color: #1890FF;
  color: white;
  text-align: center;
  padding: 30px 20px;
`;

export const Title = styled.h2`
  font-family: "Poppins-Bold";
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 8px;
  color: white;

  @media (max-width: 1024px) {
    font-size: clamp(1.5rem, 4vw, 2.5rem);
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins-Bold";
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 30px;
  color: ${props => getColor(props, 'secondary')};

  @media (max-width: 1024px) {
    font-size: clamp(1.5rem, 4vw, 2.5rem);
  }
`;

export const Subtitle = styled.p`
  font-family: "Poppins-Medium";
  font-size: 16px;
  margin-bottom: 40px;
`;

export const Features = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 60px;
  max-width: 1000px;
  margin: 0 auto;
`;

export const Feature = styled.div`
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  text-align: left;
  color: white;
`;

export const FeatureTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: "Poppins-Bold";
  font-size: 16px;
  margin-bottom: 16px;
  color: white;
`;

export const FeatureIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
`;

export const FeatureText = styled.p`
  font-family: "Poppins-Light";
  font-size: 14px;
  line-height: 1.4;
  color: white;
`;

export const AssetsSection = styled.section`
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 50px 40px;
  gap: 60px;
  flex-wrap: wrap;
`;

export const AssetsImage = styled.img`
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
`;

export const AssetsContent = styled.div`
  flex: 1;
  min-width: 300px;
`;

export const AssetsTitle = styled.div`
  font-family: "Poppins-Bold";
  font-size: 1.2rem;
  margin-bottom: 16px;
  color: ${props => getColor(props, 'secondary')};
`;

export const AssetsText = styled.div`
  font-family: "Poppins-Regular";
  font-size: 1rem;
  margin-bottom: 32px;
  color: ${props => getColor(props, 'secondary')};
`;

export const ListTitle = styled.div`
  font-family: "Poppins-Bold";
  font-weight: 600;
  margin-bottom: 8px;
  color: ${props => getColor(props, 'secondary')};
`;

export const ListItem = styled.div`
  font-family: "Poppins-Regular";
  font-size: 0.95rem;
  margin-bottom: 4px;
  color: ${props => getColor(props, 'secondary')};
`;

export const FormatGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
`;

export const GridList = styled.div`
  font-family: "Poppins-Regular";
  display: flex;
  gap: 150px;

  ul {
    list-style-type: disc;
    padding-left: 1.25rem;
  }

  @media (max-width: 1024px) {
    gap: 2rem;
    flex-wrap: wrap;
  }
`;

export const MaterialSection = styled.section`
  display: flex;
  flex-direction: row;
  padding: 60px 40px;
  gap: 60px;
  flex-wrap: wrap;
`;

export const MaterialText = styled.div`
  flex: 1;
  min-width: 300px;
`;

export const MaterialTitle = styled.h2`
  font-family: "Poppins-Bold";
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 16px;
  color: ${props => getColor(props, 'secondary')};
`;

export const MaterialDesc = styled.div`
  font-family: "Poppins-Regular";
  font-size: 1.2rem;
  color: ${props => getColor(props, 'secondary')};
`;

export const MaterialImage = styled.img`
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
`;

export const PublishingSection = styled.section`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  padding: 60px 40px;
  gap: 60px;
  flex-wrap: wrap;
  min-height: 50vh;
`;

export const PublishingText = styled.div`
  flex: 1;
  min-width: 300px;
`;
export const PublishingTitle = styled.div`
  font-family: "Poppins-Bold";
  font-size: 1.8rem;
  margin-bottom: 16px;
  color: ${props => getColor(props, 'secondary')};
`;

export const PublishingDesc = styled.div`
  font-family: "Poppins-Regular";
  font-size: 1rem;
  margin-bottom: 24px;
  color: ${props => getColor(props, 'secondary')};
`;

export const PublishingList = styled.ul`
  font-family: "Poppins-Regular";
  list-style: disc;
  padding-left: 1.25rem;
  margin-bottom: 16px;

  li {
    font-size: 0.95rem;
    margin-bottom: 4px;
    color: ${props => getColor(props, 'secondary')};
  }
`;

export const PublishingColumns = styled.div`
  display: flex;
  gap: 40px;
`;

export const PublishingImage = styled.img`
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
`;
